import { Card, CardBody, Container, Row } from "reactstrap";
import { BillingDetails, Checkouts, Ecommerce } from "../../../../utils/Constant";
import CheckoutForm from "./CheckoutForm/CheckoutForm";
import ProductCheckout from "./ProductCheckout/ProductCheckout";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";

const CheckoutContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Checkouts} parent={Ecommerce} />
      <Container fluid>
        <Card>
          <CardHeaderCommon title={BillingDetails} />
          <CardBody>
            <Row>
              <CheckoutForm />
              <ProductCheckout />
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CheckoutContainer;
